var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"scrollZoomWrapper"},[_vm._t("default",null,{"value":_vm.value}),(_vm.showControls && _vm.allowZoom)?_c('zoom-controls',_vm._b({attrs:{"value":_vm.value},on:{"input":_vm.changeZoomFactor}},'zoom-controls',_vm.$props,false),[_c('template',{slot:"extra-buttons"},[_vm._t("buttons")],2)],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }